import { render, staticRenderFns } from "./SekectShelf.vue?vue&type=template&id=6ee64e9e"
import script from "./SekectShelf.vue?vue&type=script&lang=js"
export * from "./SekectShelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports